import { QueryClient, QueryClientProvider, useQueryClient } from 'react-query';

export { getEventsById } from './api';
export {
    CONSUMER_CARD_DEFAULTS,
    EventCard,
    parseFollowSignal,
} from './components/EventCard';
export type { ShareOptionsProps } from './components/EventCard/types';
export { DEFAULT_DESTINATION_EXPANSIONS } from './constants';
export { useEvents, useEventsById, useInfiniteEvents } from './hooks';
export {
    transformDestinationEvent,
    transformDiscoveryEvent,
} from './transforms';
export type {
    DestinationEvent,
    DestinationResponse,
    DiscoveryEvent,
    FormattedEvent,
    FormattedEventResponse,
} from './types';
export { EventClient, EventClientProvider, useEventClient };

// In case the implementation changes down the line,
// export wrappers around the clients.
const EventClient = QueryClient;
const EventClientProvider = QueryClientProvider;
const useEventClient = useQueryClient;
